// extracted by mini-css-extract-plugin
export default {"formSmallText":"InputFloating_formSmallText__7l9D+","inputContainer":"InputFloating_inputContainer__eEDJx"};